import * as actions from './actions'

export const get = [
  actions.get,
]

export const save = [
  actions.save,
]
